import { render, staticRenderFns } from "./MessageImage.vue?vue&type=template&id=44f0532b&scoped=true&"
import script from "./MessageImage.vue?vue&type=script&lang=js&"
export * from "./MessageImage.vue?vue&type=script&lang=js&"
import style0 from "./MessageImage.vue?vue&type=style&index=0&id=44f0532b&prod&lang=scss&scoped=true&"
import style1 from "./MessageImage.vue?vue&type=style&index=1&id=44f0532b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f0532b",
  null
  
)

export default component.exports